export default __webpack_public_path__ + "static/img_main_product_2-81a4736200a8ec38453653dc4b25b317.png";